<template>
  <f7-page>
    <f7-navbar title="類別編輯" back-link="back"></f7-navbar>
    <f7-list
      v-if="categories"
      sortable
      :sortable-enabled="true"
      @sortable:sort="onCatetorySort($event.detail.from, $event.detail.to)"
      no-hairlines-between
      style="margin: 0px 0px 0px 0px;">
      <f7-list-item v-for="(category, index) in categories" :key="`menu-drafts-categories-edit-${index}`">
        <span
          slot="title"
          @click="$f7.dialog.prompt('類別名稱', category.title, v => setCategoryProperties({ id: category.id, properties: { title: v } }))">
          {{ category.title }}
        </span>
        <font-awesome-icon slot="after" icon="trash" style="color: red; margin-right: 10px;" @click="deleteCategoryOnClick(category.id)" />
      </f7-list-item>
      <!-- <f7-button fill raised @click="createCategory" style="margin: 10px 10%;">新增類別</f7-button> -->
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as R from 'ramda'

export default {
  computed: {
    ...mapState('menuDraftModule', ['currentDraft']),
    categories () {
      return Object.keys(this.currentDraft.categories)
        .map(k => this.currentDraft.categories[k])
        .sort((a, b) => a.categoryOrder - b.categoryOrder)
    }
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  methods: {
    ...mapActions('menuDraftModule', ['deleteCategory', 'setCategoryProperties', 'updateCategories']),
    onCatetorySort (from, to) {
      const categoryIds = this.categories.map(c => c.id)
      categoryIds.splice(to, 0, categoryIds.splice(from, 1)[0])
      this.updateCategories(categoryIds.reduce((obj, cid, i) =>
        R.assoc(
          cid,
          R.assoc('categoryOrder', i, this.currentDraft.categories[cid]),
          obj
        ), {}))
    },
    deleteCategoryOnClick (categoryId) {
      this.$f7.dialog.confirm('是否刪除該類別', '刪除類別', async () => {
        this.deleteCategory(categoryId)
      })
    }
  }
}
</script>
